export default "__VITE_ASSET__CW6Uw4rr__"